module.exports = __webpack_public_path__ + "static/media/6581d345-4212-4372-9b58-5fa778d13b51.c7229c3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/6581d345-4212-4372-9b58-5fa778d13b51.jpg
// module id = 825
// module chunks = 0